export default __webpack_public_path__ + "static/mobly-3b548a6b6d660fc7fc5eb9f530bf9d54.jpg";